import { themeUi } from '../../themeUi/themeUi';

const sessionLogs = {
  components: {
    sessionLogsHeader: {
      sessionLogsHeader: {
        headerIconButton: {
          color: themeUi.semantic.color.text.neutral700
        }
      },

      components: {
        clearButton: {
          clearButton: {
            color: themeUi.semantic.color.text.neutral700
          }
        }
      }
    }
  }
};

export default sessionLogs;
